// Константы для селекторов
const SELECTORS = {
    container: '.products-container',
    loadMoreBtn: '.pagination--catalog #load-more-btn',
    prevBtn: '.pagination--catalog #prev-page',
    nextBtn: '.pagination--catalog #next-page',
    productCards: '#productCards',
    pagination: '#pgb'
};

// Инициализация основных переменных
let currentPageProducts = jQuery(SELECTORS.productCards).data('current-page');
let maxPagesProducts = jQuery(SELECTORS.productCards).data('max-pages');
let ajaxUrlProducts = jQuery(SELECTORS.productCards).data('ajax-url');

// Управление видимостью кнопок пагинации
function updateButtonsVisibility() {
    const isFirstPage = currentPageProducts <= 1;
    const isLastPage = currentPageProducts >= maxPagesProducts;

    jQuery(SELECTORS.prevBtn).toggle(!isFirstPage);
    jQuery(SELECTORS.nextBtn).toggle(!isLastPage);
    jQuery(SELECTORS.loadMoreBtn).toggle(!isLastPage);
}

// Инициализация основных переменных
let currentSort = 'date-desc'; // По умолчанию сортировка по дате (новые сначала)

// Универсальная функция загрузки продуктов
function loadProducts(page, action, appendMode = false) {
    const categoryId = jQuery(SELECTORS.productCards).data('category-id');

    return jQuery.ajax({
        url: ajaxUrlProducts,
        type: 'POST',
        data: {action, page, category_id: categoryId, order_by: currentSort}, // Передаём текущую сортировку
        beforeSend: () => {
            if (!appendMode) {
                jQuery(SELECTORS.container).empty();
            }
            jQuery(SELECTORS.loadMoreBtn).prop('disabled', true);
        },
        success: (response) => {
            if (appendMode) {
                jQuery(SELECTORS.container).append(response);
            } else {
                jQuery(SELECTORS.container).html(response);
                document.getElementById('cS').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }

            currentPageProducts = page;
            updatePaginationLinks();
            updateButtonsVisibility();
            jQuery(SELECTORS.loadMoreBtn).prop('disabled', false);
        }
    });
}

// Функция загрузки дополнительных постов
function loadMorePosts() {
    currentPageProducts++;
    if (currentPageProducts <= maxPagesProducts) {
        loadProducts(currentPageProducts, 'load_more_products', true);
    }
}

// Генерация HTML для элемента пагинации
function getPaginationItemHTML(i) {
    const isActive = i == currentPageProducts ? 'pagination__item--active' : '';
    return `
        <li class="pagination__item ${isActive}">
            <a href="javascript:void(0);" class="pagination-link" data-page="${i}">${i}</a>
        </li>
    `;
}

// Обновление ссылок пагинации
function updatePaginationLinks() {
    const paginationHTML = Array.from({length: maxPagesProducts}, (_, i) => i + 1)
        .map(getPaginationItemHTML)
        .join('');

    jQuery(SELECTORS.pagination).html(paginationHTML);
}

// Инициализация обработчиков событий
jQuery(document).ready(() => {
    updateButtonsVisibility();
    updatePaginationLinks();

    // Обработчик клика по номеру страницы
    jQuery(SELECTORS.pagination).on('click', '.pagination-link', function (e) {
        e.preventDefault();
        const page = jQuery(this).data('page');
        if (page != currentPageProducts) {
            loadProducts(page, 'load_products_page');
        }
    });

    // Обработчик кнопки "Загрузить еще"
    jQuery(SELECTORS.loadMoreBtn).click(loadMorePosts);

    // Обработчик кнопки "Предыдущая страница"
    jQuery(SELECTORS.prevBtn).click((e) => {
        e.preventDefault();
        if (currentPageProducts > 1) {
            loadProducts(currentPageProducts - 1, 'load_products_page');
        }
    });

    // Обработчик кнопки "Следующая страница"
    jQuery(SELECTORS.nextBtn).click((e) => {
        e.preventDefault();
        if (currentPageProducts < maxPagesProducts) {
            loadProducts(currentPageProducts + 1, 'load_products_page');
        }
    });
});

// Обработчик клика по кнопке сортировки
jQuery('#dropSort a').on('click', function (e) {
    e.preventDefault();

    const sortKey = jQuery(this).data('sort'); // Получаем новый ключ сортировки
    const sortText = jQuery(this).text(); // Текст сортировки для отображения

    currentSort = sortKey; // Обновляем текущую сортировку
    jQuery('#currentSortText').text(sortText);
    jQuery('.catalog__sort-drop').removeClass('activated');
    jQuery('.catalog__sort-block').removeClass('activated');
    jQuery('#ajax-search-form input[name="s"]').val('');
    // Загружаем первую страницу с новой сортировкой
    loadProducts(1, 'load_products_page');

});
document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.category-checkbox');

    checkboxes.forEach(checkbox => {
        // Проверка URL для выбора чекбокса
        const categoryUrl = checkbox.getAttribute('data-url');
        if (window.location.href === categoryUrl) {
            checkbox.checked = true;
        }

        // Обработка выбора категории
        checkbox.addEventListener('change', function () {
            if (this.checked) {
                window.location.href = categoryUrl;
            }
        });
    });

    // Логика сортировки
    const sortSelect = document.querySelector('#sort-select'); // Если используется select для сортировки
    if (sortSelect) {
        sortSelect.addEventListener('change', function () {
            const sortValue = this.value;
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('orderby', sortValue); // Параметр сортировки
            window.location.href = currentUrl.href;
        });
    }
});


// Search
document.addEventListener('DOMContentLoaded', function () {
    const searchForm = document.querySelector('#ajax-search-form');
    const searchInput = searchForm.querySelector('input[name="s"]');
    const productContainer = jQuery(SELECTORS.container);

    if (!searchForm || !searchInput) return;

    searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim();
        performSearch(query);
    });

    const productCountBase = jQuery('.catalog__qty span').text();

    function performSearch(query) {
        const categoryId = jQuery(SELECTORS.productCards).data('category-id');


        // Если поле пустое, загружаем изначальные товары
        if (!query) {
            loadProducts(1, 'load_products_page'); // Загружаем первую страницу
            jQuery('.pagination').show();
            jQuery('.catalog__qty span').html(productCountBase);
            return;
        }

        // Выполняем AJAX-поиск
        jQuery.ajax({
            url: ajaxUrlProducts,
            type: 'POST',
            data: {
                action: 'perform_ajax_search',
                s: query,
                category_id: categoryId,
                order_by: currentSort,
            },
            beforeSend: () => {
                productContainer.empty();
                jQuery(SELECTORS.loadMoreBtn).prop('disabled', true);
            },
            success: (response) => {
                productContainer.html(response);
                currentPageProducts = 1;
                updatePaginationLinks();
                updateButtonsVisibility();
                jQuery(SELECTORS.loadMoreBtn).prop('disabled', false);
                jQuery('.pagination').hide();


                // Пересчитываем количество карточек товаров
                const productCount = jQuery('.catalog__card').length;
                console.log('Количество товаров:', productCount); // Для отладки

                jQuery('.catalog__qty span').html(productCount);
            },
            error: (error) => {
                console.error('Ошибка AJAX-поиска:', error);
                productContainer.html('<p>Произошла ошибка при поиске.</p>');
            },
        });
    }
});

// toggle

document.addEventListener('DOMContentLoaded', function () {
    jQuery('.btn__filter-toggle').click(function () {
        jQuery('.catalog__category').toggle();
    });
});
